exports = module.exports = require("../../node_modules/css-loader/dist/runtime/api.js")(false);
// Module
exports.push([module.id, "header#page-header.page-header-wrapper{width:100%;position:fixed;top:0;left:0;opacity:1;z-index:201;transition:transform 1s cubic-bezier(.46,0,.07,1)}header#page-header.page-header-wrapper.hide-menu{transform:translateY(-100%)}", ""]);

